// Phase 10A.1 R0/R1 — Pitch page mock-data purge.
//
// Removed in this slice:
//   - MOCK_FREE_ACCA (fictional 3-leg accumulator with Liverpool vs
//     Arsenal, fake combined-odds figure, fake "Next drop in 4h").
//   - MOCK_FOUNDERS_PICKS (fictional founder picks list).
//   - MOCK fallback. The page uses usePitchPicks against the real
//     daily_slips boundary; when no real free-acca exists, the page
//     renders a truthful empty state.

import { Icon } from "../../components/icons/Icon.tsx";
import { usePitchPicks } from "../../pitch/usePitchPicks.ts";
import { AwaitingDataPanel } from "../_awaiting-data.tsx";
import { DoctrineSection } from "../../components/DoctrineSection.tsx";
import { useDoctrinePicks } from "../../doctrine/useDoctrinePicks.ts";

export function PitchPage(): JSX.Element {
  const { slips, loading, error } = usePitchPicks();
  const {
    probabilityPicks: doctrineProbPicks,
    valuePicks: doctrineValuePicks,
    substrateEmpty,
    substrateWeek,
  } = useDoctrinePicks({ t1HasPicks: slips.length > 0 });

  return (
    <>
      <div className="ex-head">
        <div>
          <h1>The Pitch · Sankofa</h1>
          <div className="sub">
            Daily free public-ready accumulator from the agent pipeline. Read-only.
          </div>
        </div>
        <div className="pill-row">
          <span className="tag">Free · public</span>
        </div>
      </div>

      <div className="disclosure">
        <Icon name="info" size={14} />
        <span>
          Manual placement only. The Pitch is a free read-only intelligence drop. STRIKZA does not
          place anything for you and never publishes a track record.
        </span>
      </div>

      {loading ? (
        <AwaitingDataPanel
          eyebrow="The Pitch"
          title="Loading…"
          body="Authenticated read pending."
        />
      ) : error !== null ? (
        <AwaitingDataPanel eyebrow="The Pitch" title="Pitch unavailable." body={error} />
      ) : slips.length === 0 ? (
        <>
        <AwaitingDataPanel
          eyebrow="The Pitch"
          title="No public free acca prepared yet."
          body={
            <>
              When the agent pipeline produces a public-ready free accumulator through the curated
              daily_slips boundary, it appears here. STRIKZA never publishes a fabricated free acca.
            </>
          }
        />
        <DoctrineSection
          probabilityPicks={doctrineProbPicks}
          valuePicks={doctrineValuePicks}
          isFullFallback
          substrateEmpty={substrateEmpty}
          substrateWeek={substrateWeek}
        />
        </>
      ) : (
        <p
          style={{
            marginTop: 24,
            fontFamily: "var(--font-mono, monospace)",
            fontSize: 13,
            color: "var(--text-secondary, #888)",
          }}
        >
          {slips.length} prepared pitch slip(s). Detail rendering ships in a later phase against the
          curated public-read boundary.
        </p>
      )}
    </>
  );
}
